<script lang="ts" setup>
import type { ResponsiveImageType } from "vue-datocms";
import type { HeaderSectionRecord } from "~~/server/graphql/datocms/generated";
import { Image as DatocmsImage } from "vue-datocms";

defineProps<{ data: HeaderSectionRecord; pageTitle: string; currentPageId: string }>();
</script>

<template>
  <div class="mb-xl lg:mb-3xl">
    <div class="header-container">
      <div v-if="data.item" class="header-container__img">
        <DatocmsImage
          :data="data.item.responsiveImage as ResponsiveImageType"
          :lazy-load="false" object-fit="cover" class="size-full md:rounded-2xl"
        />
      </div>

      <div class="header-container__content z-1">
        <div class="p-lg flex h-full flex-col items-center justify-end md:items-start">
          <h1 class="text-white">
            {{ pageTitle }}
          </h1>
        </div>
      </div>
    </div>

    <div v-if="data.optIntro" class="html-content mt-3xl w-full lg:w-3/5" v-html="data.optIntro" />
  </div>
</template>

<style scoped>
.header-container {
  display: grid;
  grid-template-areas: "stack";

  .header-container__img {
    grid-area: stack;
  }

  .header-container__content {
    grid-area: stack;
  }
}

h1 {
  text-shadow: rgba(0, 0, 0, 0.6) 0 0 0.5rem;
}
</style>
